module.exports = __webpack_public_path__ + "img/first.d108f6c1.jpg";